import {
  Controller,
  useFormContext,
  FieldValues,
  FieldPath,
} from "react-hook-form";
import { TagsInput as BaseTagsInput } from "../../TagsInput";
import { TagsInputFormProps } from "../types";
import { withFormField } from "./withFormField";

function TagsInputUnwrapped<T extends FieldValues>(
  props: TagsInputFormProps & { name: FieldPath<T> },
): JSX.Element {
  const { control } = useFormContext<T>();
  return (
    <Controller
      name={props.name}
      control={control}
      render={({ field }) => (
        <BaseTagsInput
          {...props}
          value={field.value}
          onChange={field.onChange}
          onBlur={field.onBlur}
        />
      )}
    />
  );
}

export const TagsInput = withFormField(TagsInputUnwrapped);
